import React from "react";

/**
 * PageHero — cabeçalho padrão para páginas internas.
 * Usa imagem de fundo editável via settings + overlay para contraste garantido.
 */
export default function PageHero({ image, overline, title, subtitle, align = "left" }) {
  const alignCls = align === "center" ? "text-center max-w-3xl mx-auto" : "max-w-3xl";
  return (
    <section className="relative overflow-hidden bg-[color:var(--marupiara-obsidian)]">
      {image ? (
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" style={{ opacity: 0.35 }} />
      ) : null}
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(10,10,10,0.65), rgba(10,10,10,0.9))" }} />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-28">
        <div className={alignCls}>
          {overline && <div className="overline text-[color:var(--marupiara-gold-light)] mb-4">{overline}</div>}
          <h1 className="font-serif text-5xl sm:text-6xl leading-[1.05] text-[color:var(--marupiara-text-on-dark)]">{title}</h1>
          {subtitle && <p className="mt-5 text-lg text-[color:var(--marupiara-text-on-dark-muted)] max-w-2xl">{subtitle}</p>}
        </div>
      </div>
    </section>
  );
}
